import { Box, styled } from '@mui/material';

import { ContentContainerStyle, NavMenuContainerStyle } from './NavMenu.types';

const scrollWidth = 8;
const contentMarginRight = 2;
const scrollBorderRadius = 10;

export const BackgroundContainer = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  position: 'relative',
}));

export const NavMenuContainer = styled(Box)(
  ({ background }: NavMenuContainerStyle) => ({
    width: '100%',
    height: '100%',
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    backgroundColor: background,

    '@media screen and (max-width: 640px)': {
      gridTemplateColumns: 'auto 1fr',
    },
  }),
);

export const ContentContainer = styled(Box)(
  ({ secondary, highlight }: ContentContainerStyle) => ({
    width: `calc(100% - ${contentMarginRight}px)`,

    overflow: 'auto',

    scrollbarWidth: 'thin',
    scrollbarColor: `${secondary} ${highlight}`,

    /* width */
    '&::-webkit-scrollbar': {
      width: `${scrollWidth}px`,
    },

    /* Track */
    '&::-webkit-scrollbar-track': {
      width: `${scrollWidth}px`,
      borderRadius: `${scrollBorderRadius}px`,
      backgroundColor: highlight,
    },

    /* Handle */
    '&::-webkit-scrollbar-thumb': {
      background: secondary,
      borderRadius: `${scrollBorderRadius}px`,
    },
  }),
);
